import { useI18n } from '@i18n/useI18n';
import { GridWrapper } from '@components/GridCards/Common.styled';
import db from '@utils/db';

// Profile modules
import ProfileAchievement from './ProfileAchievement';
import { useStore } from '@store/appStore';
import { forwardRef, ReactElement, useEffect, useImperativeHandle, useRef, useState } from 'react';
import CourseAbsence from '../GridCards/CourseAbsence';
import Badges from '@models/Badges';
import ProfileRewardRedeem from './ProfileRewardRedeem/ProfileRewardRedeem';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import AbsenceProjection from '@components/GridCards/AbsenceProjection';
import HeatMap from '@components/GridCards/HeatMap';
import { useRouter } from 'next/router';
import styled from "@emotion/styled";
import { Devices } from '@styles/tokens';
import { mq } from '@styles/helpers';
import ProfileStreak from './ProfileStreak';
import ProfileCoins from './ProfileCoins/ProfileCoins';
import { calculatePercentage } from '@utils/percentageTools';
import Modal from '@components/Buttons/Modal';
import { HalfContent, ModalContent } from './Profile.styled';
import { Button } from '@components/GuardianEditor/GuardianEditor.styled';
import ProfileImageGraph from './ProfileImageGraph';
import AttendanceCalendar from './AttendanceCalendar';
import ActivePresence from './ActivePresence';
import moment from 'moment';
import persistentStore from '@store/persistentStore';


interface IProps {
  id: string;
  user_id:string;
  sisId?: string;
  total: any;
  day: any;
  firstname: string;
  lastname?: string;
  lastLogin: any;
  isAdmin?: boolean;
  pinnedStudents?: any;
  pin?: (id, pin) => any;
  notePresent?: boolean;
  noteCount?: number;
  counselor?: boolean;
  guardian?: boolean;
  schoolView?: boolean;
  updateTime?:any;
  open?:boolean;
  setOpen?:(bool: boolean) => void,
  guardianChildren?:ReactElement;
}

export const Profile = forwardRef((props: IProps, ref) => {
  useImperativeHandle(ref, () => ({
    rewardScreen() {
      setRewardScreenBadge(tempBadge);
      setRewardScreen(true);
    },
  }));
  const i18n = useI18n();
  const pointRef = useRef(null);
  const badgeRef = useRef(null);
  const coinRef = useRef(null);
  const [previousRewardScreen, setPreviousRewardScreen] = useState(false);
  const { defaultQr } = persistentStore();
  const {
    callNameSetting,
    settings,
    rewardScreen,
    setRewardScreen,
    setRewardScreenBadge,
    client,
    systemSettings,
    alerts,
    groups,
    checkin,
    clientSettings,
    setQRScreen
  } = useStore();
  const tempBadge = { title: 'badge-title-1', badgeImage: Badges.welcome, stage: 1, rewardDecription: 'badge-reward-1' };
  const [userGamification, setUserGamification] = useState({ coins: false, badges: false, streaks: false, rewards: false });
  const [loading, setLoading] = useState(true);
  let school = 'Arosskole Demo'
  let schoolSetting = systemSettings.find(s => s.APP_Setting_ID === 65)
  school = schoolSetting?.value
  let totalAbs = 0;

  if (settings.USE_LESSON_BASED_ABSENCE === 'true') {
    totalAbs = Number(props.total?.lessonspercentage?.toFixed(1));
  } else {
    if (props.total?.merit) {
      totalAbs = Number(calculatePercentage(props.total.secondcount, props.total.secondabsence).toFixed(1));
    }
    else
      totalAbs = Number(props.total?.secondpercentage?.toFixed(1));
  }

  let allowNotes = systemSettings.find(t => t.APP_Setting_ID === 9)  

  useEffect(() => {
    if (client.UseGamificationPerDepartment) {
      setLoading(true);
      getUserGamificationSettings();
    } else {
      setLoading(false);
    }
  }, [props.id]);

  useEffect(() => {
    if (pointRef.current) {
      pointRef.current.startPoints(props.isAdmin);
    }
  }, [userGamification, pointRef.current]);

  const getUserGamificationSettings = async () => {
    setUserGamification({ coins: false, badges: false, streaks: false, rewards: false });
    let userInfo = await db.getUserInfo(props.id);
    if (userInfo?.[0]?.department !== null && userInfo?.[0]?.department !== undefined && userInfo[0].department.length > 0) {
      let department = await db.getDepartmentSettings(userInfo[0].department);
      if (department?.length > 0) {
        setUserGamification({
          coins: department[0].coins,
          badges: department[0].badges,
          streaks: department[0].badges,
          rewards: department[0].rewards,
        });
      } else {
        setUserGamification({ coins: false, badges: false, streaks: false, rewards: false });
      }
    } else {
      setUserGamification({ coins: false, badges: false, streaks: false, rewards: false });
    }
    setLoading(false);
  };

  const closeRewardScreen = () => {
    if (pointRef.current) pointRef.current.startPoints(props.isAdmin);
    if (badgeRef.current) badgeRef.current.setBadge();
  };

  useEffect(() => {
    if (rewardScreen === false && previousRewardScreen === true) {
      closeRewardScreen();
    } else {
      setPreviousRewardScreen(rewardScreen);
    }
  }, [rewardScreen]);

  const pin = () => {
    props.pin(
      props.sisId,
      props.pinnedStudents?.some((a) => a.username === props.id),
    );
  };

  const updateCoins = () => {
      coinRef?.current?.update()
  }


  const getGamification = () => {
    let gamification = [];
    if (props.isAdmin && client.UseGamificationPerDepartment) {
      //if (userGamification.streaks) gamification.push(<AttendanceStreak studentId={props.id} />);
      if (userGamification.streaks) gamification.push(<ProfileStreak key="streak" guar={props.guardian} studentId={props.id} checkonly={props.isAdmin || props.counselor} updateTime={props.updateTime} />);
      if (userGamification.coins) gamification.push(<ProfileCoins key="coins" ref={coinRef} guar={props.guardian} studentId={props.id} admin={props.isAdmin || props.counselor} updateTime={props.updateTime} />);
      if (userGamification.badges) gamification.push(<ProfileAchievement key="badges" ref={badgeRef} studentId={props.id} isAdmin={props.isAdmin} updateTime={props.updateTime} />);
      if (userGamification.rewards) gamification.push(<ProfileRewardRedeem key="rewards" updateCoins={updateCoins} studentId={props.id} isAdmin={props.isAdmin} updateTime={props.updateTime} />);
    } else {
      // if (settings.USESTREAKS) gamification.push(<AttendanceStreak studentId={props.id} />);
      if (settings.USESTREAKS) gamification.push(<ProfileStreak key="streak" guar={props.guardian} studentId={props.id} checkonly={props.isAdmin || props.counselor} updateTime={props.updateTime} />);
      if (settings.USECOINS) gamification.push(<ProfileCoins key="coins" ref={coinRef} guar={props.guardian} studentId={props.id} admin={props.isAdmin || props.counselor} updateTime={props.updateTime}/>);
      if (settings.USEBADGES) gamification.push(<ProfileAchievement key="badges" ref={badgeRef} studentId={props.id} isAdmin={props.isAdmin} updateTime={props.updateTime} />);
      if (settings.USEREWARDS) gamification.push(<ProfileRewardRedeem key="rewards" updateCoins={updateCoins} studentId={props.id} isAdmin={props.isAdmin} updateTime={props.updateTime} />);
    }

    return gamification;
  };

  let prediction = systemSettings.find((s) => s.APP_Setting_ID === 55);

  
  const [checkedIn, setCheckedIn] = useState({checkin: false, time: ""})
  const modalRef = useRef(null)

  useEffect(() => {
    CheckStudentState()
  }, [props.updateTime, checkin])

  const CheckStudentState = async () => {
      let timeZone = systemSettings?.find((t) => t.APP_Setting_ID === 7);
      let checkStudent = await db.Student_GetCheckInOut(props.id, 'UTC', '1');
      if (checkStudent?.length > 0 && checkStudent[0]?.checkin) {
        setCheckedIn({checkin: true, time: checkStudent[0]?.local_timestamp});
      } else {
        setCheckedIn({checkin: false, time: ""});
        let defaultCamera = clientSettings?.find((t) => t?.APP_Setting_ID === 102)
        let firstLoad = sessionStorage.getItem("firstLoad")
        console.log(firstLoad)
        if(defaultCamera?.value === "true" && firstLoad === null){
          sessionStorage.setItem("firstLoad", "true")
          setQRScreen(true)
        }else{
          console.log(defaultQr, firstLoad)
          if(defaultQr && firstLoad === null){
            sessionStorage.setItem("firstLoad", "true")
            setQRScreen(true)
          } 
        }
      }
  }; 

  return (<>
    {props.open?<Modal ref={modalRef} backColor={"rgba(0,0,0,0.25)"} onClose={props.setOpen} >
      <ModalContent>
        <HalfContent>
          <p>{i18n.t("profile-empty-text")}</p>
        </HalfContent>
        <Button onClick={() => modalRef.current.handleClose()}>OK</Button>
      </ModalContent>
    </Modal>:null}

    <GridWrapper>
      {loading ? (
        <RainbowLoader />
      ) : (
        <>

         {checkedIn.checkin && groups?.includes(client?.StudentGroupName) && !props.guardian?<ActivePresence time={checkedIn.time} />:null}
          
          {/* <ProfileImage
            id={props.id}
            sisId={props.sisId}
            firstname={props.firstname}
            lastname={props.lastname}
            admin={props.isAdmin}
            noteCount={props.noteCount}
            notePresent={props.notePresent}
            counselor={props.counselor}
          >
            {getButtons()}
          </ProfileImage> */}
          {/* <ProfileAbsence totalAbs={totalAbs} chartDays={props.day} admin={props.counselor || props.isAdmin} /> */}
          {props.guardianChildren}
          <ProfileImageGraph  
            username={props.id} 
            firstname={props.firstname} 
            lastname={props.lastname} 
            totalAbs={totalAbs} 
            chartDays={props.day} 
            admin={props.isAdmin} 
            id={props.id}
            sisId={props.sisId}
            noteCount={props.noteCount}
            notePresent={props.notePresent}
            counselor={props.counselor}
            schoolView={props.schoolView}
            guardian={props.guardian}  
            pinnedStudents={props.pinnedStudents}
            pin={pin}          
            />
          {!props.guardian?<AttendanceCalendar user_id={props.user_id} username={props.id} updateTime={props.updateTime} />:null}
          {props.counselor ? null : getGamification()}
          {/* <RegistrationList username={props.id} sort={true} admin={props.counselor || props.isAdmin} updateTime={props.updateTime} /> */}
          {<HeatMap id={props.id} updateTime={props.updateTime} />}
          {(props.isAdmin || (prediction.value.toLowerCase() === 'true' && settings.DEMO !== true && settings.DEMO !== "true")) ? (
            <AbsenceProjection userId={props.sisId} userSisId={props.id} updateTime={props.updateTime} />
          ) : null}
          <CourseAbsence guar={props.guardian} userId={props.id} updateTime={props.updateTime} />
        </>
      )}
    </GridWrapper>
  </>);
});

export default Profile;
